// extracted by mini-css-extract-plugin
export var statItem = "_le-1";
export var statsRow = "_le-0";